import { z } from "zod";

export type Submit = z.infer<typeof SubmitSchema>;
export const SubmitSchema = z.object({
  label: z.string(),
});
